import React, { useState, useEffect } from 'react';
import axios from 'axios';

function SalesPage({ apiUrl, auth }) {
  const [rentals, setRentals] = useState([]);
  const [dateFilter, setDateFilter] = useState('');

  const isAdmin = auth.user?.role === 'admin';
  const headers = { Authorization: `Bearer ${auth.token}` };

  useEffect(() => {
    loadRentals();
  }, [dateFilter]);

  const loadRentals = async () => {
    try {
      const params = dateFilter ? { date: dateFilter } : {};
      const res = await axios.get(`${apiUrl}/rentals`, { params });
      setRentals(res.data);
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  const handleDelete = async (sale) => {
    const label = sale.type === 'wallet' ? 'cette vente portefeuille' : `le ticket #${sale.ticket_number}`;
    const extra = sale.type === 'wallet' && !sale.is_vip ? '\nLe montant sera recrédité au solde du client.' : '';
    if (!window.confirm(`Supprimer ${label} ?${extra}`)) return;
    try {
      const url = sale.type === 'wallet'
        ? `${apiUrl}/clients/transaction/${sale.id}`
        : `${apiUrl}/rentals/${sale.id}`;
      await axios.delete(url, { headers });
      loadRentals();
    } catch (err) {
      alert(err.response?.data?.error || 'Erreur lors de la suppression');
    }
  };

  const totalRevenue = rentals.reduce((sum, r) => sum + (r.is_vip ? 0 : r.total), 0);

  return (
    <div>
      <div className="page-header">
        <h1>🧾 Ventes</h1>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="date"
            value={dateFilter}
            onChange={e => setDateFilter(e.target.value)}
            style={{ padding: '8px 12px', border: '1px solid var(--border)', borderRadius: '8px', fontSize: '14px' }}
          />
          {dateFilter && (
            <button className="btn btn-outline btn-sm" onClick={() => setDateFilter('')}>
              Tout afficher
            </button>
          )}
        </div>
      </div>

      <div className="stats-grid" style={{ marginBottom: '20px' }}>
        <div className="stat-card revenue">
          <div className="stat-label">Total {dateFilter ? `du ${new Date(dateFilter).toLocaleDateString('fr-FR')}` : 'général'}</div>
          <div className="stat-value">{totalRevenue.toFixed(0)} DA</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Nombre de ventes</div>
          <div className="stat-value">{rentals.length}</div>
        </div>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Vente</th>
              <th>Articles</th>
              <th>Total</th>
              <th>Employé</th>
              <th>Date & Heure</th>
              {isAdmin && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {rentals.length === 0 ? (
              <tr><td colSpan={isAdmin ? 6 : 5} style={{ textAlign: 'center', padding: '40px', color: 'var(--text-secondary)' }}>Aucune vente trouvée</td></tr>
            ) : (
              rentals.map(sale => (
                <tr key={sale.id}>
                  <td>
                    {sale.type === 'wallet' ? (
                      <span className={`badge ${sale.is_vip ? 'badge-warning' : 'badge-info'}`}>
                        {sale.is_vip ? '⭐ VIP' : '📱'} {sale.client_name || 'Client'}
                      </span>
                    ) : (
                      <span className="badge badge-info">#{sale.ticket_number}</span>
                    )}
                  </td>
                  <td>{sale.items.map(i => `${i.name} x${i.qty || i.quantity || 1}`).join(', ')}</td>
                  <td style={{ fontWeight: '700', color: sale.is_vip ? '#B45309' : 'var(--success)' }}>
                    {sale.total.toFixed(0)} DA{sale.is_vip ? ' (gratuit)' : ''}
                  </td>
                  <td>{sale.employee_name || '-'}</td>
                  <td style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
                    {sale.created_at ? new Date(sale.created_at).toLocaleDateString('fr-FR', {
                      day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
                    }) : '-'}
                  </td>
                  {isAdmin && (
                    <td>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(sale)}>🗑 Supprimer</button>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SalesPage;
